import { render, staticRenderFns } from "./tabnav.pug?vue&type=template&id=17214efe&lang=pug&"
import script from "./tabnav.js?vue&type=script&lang=js&"
export * from "./tabnav.js?vue&type=script&lang=js&"
import style0 from "./tabnav.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/macmaum1/Desktop/GARAJE/mavalue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17214efe')) {
      api.createRecord('17214efe', component.options)
    } else {
      api.reload('17214efe', component.options)
    }
    module.hot.accept("./tabnav.pug?vue&type=template&id=17214efe&lang=pug&", function () {
      api.rerender('17214efe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tabnav/index.vue"
export default component.exports